<div class="option-container centered" [matTooltip]="label" matTooltipPosition="right">
  <button
    mat-flat-button
    class="option-button"
    (click)="onSelect()"
    [disabled]="disabled"
    [attr.data-testid]="'option-' + value + '-button'"
  >
    <div class="accessory-left">
      <ng-content select="[accessory-left]"></ng-content>
      <span class="label">{{ label ?? '' | truncate: 25 }}</span>
      <ng-content select="[accessory-right]"></ng-content>
    </div>
  </button>
</div>
